<template>
  <form class="search-bar-form" method="get" role="search" @submit.prevent="onSearch">
    <div ref="search" class="search-bar input" :class="{ 'show-suggestions': showSuggestions, focus: focussed }">
      <input
        ref="searchInput"
        v-model="inputValue"
        :tabindex="show ? 0 : -1"
        class="search-bar-input"
        :class="{ 'show-suggestions': showSuggestions, focus: focussed }"
        type="search"
        name="q"
        value=""
        placeholder="Search for products and help topics..."
        autocomplete="off"
        autocapitalize="off"
        autocorrect="off"
        spellcheck="false"
        aria-label="Search"
        maxlength="1000"
        @input="onType"
        @keydown.esc.prevent="onEscape"
        @focus="onFocus"
        @click="onClick"
        @blur="onBlur"
        @keydown.down.prevent="onDown"
      />
      <a
        v-if="query"
        tabindex="0"
        class="search-bar-cancel-button"
        :class="{ focus: focussed || showSuggestions }"
        @focus="onFocus"
        @blur="onBlur"
        @click.prevent="onCancel()"
      >
        <i class="af af-close"></i>
      </a>
      <a
        tabindex="0"
        class="search-bar-search-button"
        :class="{ 'show-suggestions': showSuggestions, focus: focussed || showSuggestions }"
        @focus="onFocus"
        @blur="onBlur"
        @click.prevent="onSearch()"
      >
        <i class="af af-search"></i>
      </a>
    </div>
    <hr v-if="showSuggestions" class="search-bar-mobile-divider" />
    <div v-if="showSuggestions" class="search-bar-suggestions-container">
      <div class="search-bar-suggestions">
        <slot name="suggestions"></slot>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  props: ['show', 'showSuggestions', 'query'],

  data() {
    return {
      inputValue: null,
      focussed: false,
    };
  },

  watch: {
    query: {
      handler(val) {
        this.inputValue = val;
      },
    },
  },

  created() {
    this.inputValue = this.query || '';
  },

  methods: {
    onSearch() {
      if (this.query) {
        this.$emit('search', this.inputValue);
      } else {
        this.$refs.searchInput.focus();
      }
    },

    onCancel() {
      this.inputValue = '';
      this.$emit('type', '');
      this.$refs.searchInput.focus();
    },

    onType(e) {
      this.$emit('type', e.target.value);
    },

    onDown() {
      this.$emit('down');
    },

    focus() {
      this.$refs.searchInput.focus();
    },

    blur() {
      this.$refs.searchInput.blur();
    },

    onEscape() {
      this.blur();
      this.$emit('blur');
    },

    onFocus() {
      this.focussed = true;
    },

    onClick() {
      if (this.inputValue) {
        this.$emit('type', this.inputValue);
      }
    },

    onBlur() {
      this.$emit('update:focussed', false);
    },
  },
};
</script>
<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.search-bar-form {
  .search-bar {
    overflow: hidden;
    position: relative;
    display: flex;
  }

  .search-bar-input,
  .search-bar-search-button,
  .search-bar-cancel-button {
    width: auto;
    flex-shrink: 0;
  }

  .search-bar-input {
    color: var(--font-color);
    flex-grow: 1;
    font-size: var(--font-size);
    font-family: var(--font-regular);
    border: none;

    &:focus,
    &.focus,
    &.show-suggestions {
      border-right: none;
      -webkit-appearance: none;
      outline: none;
      background: white;
    }

    &::placeholder {
      font-size: var(--font-size);
      color: var(--grey-medium);
    }

    &::-webkit-search-cancel-button {
      -webkit-appearance: none;
    }
  }

  .search-bar-cancel-button {
    display: flex;
    align-items: center;
    flex-grow: 0;
    padding-left: var(--space-4);
  }

  .search-bar-search-button {
    display: flex;
    align-items: center;
    flex-grow: 0;
    padding-left: var(--space-4);

    @media (min-width: $mobile-breakpoint) {
      &.show-suggestions {
        border-radius: 0px 4px 0px 0px;
      }
    }
  }

  .search-bar-mobile-divider {
    display: none;

    @media (max-width: $mobile-breakpoint - 1) {
      display: block;
      margin-top: 20px;
      margin-left: -20px;
      margin-right: -20px;
    }
  }

  .search-bar-suggestions-container {
    position: relative;
  }

  .search-bar-suggestions {
    z-index: 11;
    padding: var(--space-4);
    border-top: none;
    border-radius: 4px;
    background: white;
    position: absolute;
    margin-top: 1px;
    top: 0;
    left: 0;
    right: 0;
    box-shadow: 0 var(--box-shadow-blur) var(--box-shadow-spread) var(--shadow-color);

    @media (max-width: $mobile-breakpoint - 1) {
      position: static;
      border: none;
      padding: 10px 0px 0px 0px;
      margin-bottom: 70px;
      box-shadow: none;
    }
  }
}
</style>
